import { atom } from "recoil";

export const matchRequestResDataState = atom({
  key: "matchRequestResDataState",
  default: {},
});
